<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Edit User</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form :fields="user" method="put" :action="url" @submitted="$emit('edited', $event)">
          <custom-input v-if="isTemporary" name="first_name" label="First name" />
          <custom-input v-if="isTemporary" name="last_name" label="last name" />
          <custom-input name="email" label="Email Address" />
          <custom-input name="country_code" label="Country Code" />
          <custom-input name="phone_number" label="Phone Number" />
          <custom-input name="monthly_revenue" label="Monthly Revenue" />
          <custom-input name="birth_location" label="Place of Birth" />
          <custom-select
            :items="countries"
            name="birth_country"
            item-text="name"
            item-value="name"
            label="Country of Birth"
          />
          <custom-input v-if="isDistributor" name="location" label="Location" />
          <custom-textarea name="reason_for_modification" label="Update Reason" />
          <custom-button block color="primary">
            <v-icon>mdi-account-edit</v-icon>Edit
          </custom-button>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    user: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      isTemporary: this.user.client && this.user.client.type === "temporary-customer",
      countries: [],
      isDistributor:
        this.user.client && this.user.client.type.toLocaleLowerCase().includes("distributor"),
    };
  },
  computed: {
    url() {
      if (this.isTemporary) {
        return `/api/v1/users/temporary/update/${this.user.id}`;
      }
      return `/api/v1/users/${this.user.id}`;
    },
  },
  created() {
    this.$http.get("/api/v1/get-countries").then((response) => (this.countries = response));
  },
};
</script>
